module.exports = __webpack_public_path__ + "img/logo.c5859412.png";